export default __webpack_public_path__ + "static/media/settings.dea10f75.svg";